import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { useTranslation } from 'react-i18next';

const CertificatesArea = () => {
    const { t } = useTranslation();
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const certificates = [
        {
            id: 1,
            img: '/img/b1.jpg',
            title: 'ISO 9001:2015',
            desc: 'Kalite Yönetim Sistemi / Quality Management System'
        },
        {
            id: 2,
            img: '/img/b2.jpg',
            title: 'ISO 14001:2015',
            desc: 'Çevre Yönetim Sistemi / Environmental Management System'
        },
        {
            id: 3,
            img: '/img/b3.jpg',
            title: 'ISO 45001:2018',
            desc: 'İş Sağlığı ve Güvenliği Yönetim Sistemi / Occupational Health and Safety Management System'
        }
    ];

    const images = certificates.map(cert => cert.img);

    return (
        <>
            {isOpen && (
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                    }
                />
            )}

            <section className="portfolio-area pt-120 pb-90">
                <div className="container">
                    <div className="row">
                        {certificates.map((item, index) => (
                            <div key={item.id} className="col-lg-4 col-md-6 grid-item">
                                <div className="portfolio-item mb-30">
                                    <div className="portfolio-wrapper">
                                        <div className="portfolio-image">
                                            <img src={item.img} alt={item.title} style={{ width: '100%', height: 'auto', borderRadius: '10px' }} />
                                            <div className="view-icon" onClick={() => {
                                                setPhotoIndex(index);
                                                setIsOpen(true);
                                            }}>
                                                <button className="popup-image">
                                                    <i className="fas fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="portfolio-caption">
                                            <h4>{item.title}</h4>
                                            <p>{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default CertificatesArea;
